export const AvatarNavbarGamingTechnologyIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1466_6442)">
        <path
          d="M10 0.63V5.63"
          stroke="#737373"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 11.88V15.63"
          stroke="#737373"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.13 13.75H6.88"
          stroke="#737373"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 12.5H13.75V13.75H15V12.5Z"
          fill="#737373"
        />
        <path
          d="M17.5 13.75H16.25V15H17.5V13.75Z"
          fill="#737373"
        />
        <path
          d="M15 9.38H5C4.22 9.37 3.44 9.57 2.77 9.97C2.09 10.36 1.53 10.93 1.15 11.62C0.76 12.3 0.57 13.08 0.59 13.86C0.61 14.65 0.84 15.41 1.26 16.07C1.68 16.74 2.26 17.28 2.96 17.64C3.66 18 4.44 18.16 5.22 18.12C6 18.07 6.76 17.82 7.41 17.38C8.06 16.94 8.58 16.33 8.92 15.63H11.08C11.42 16.33 11.94 16.93 12.59 17.36C13.24 17.8 13.99 18.05 14.77 18.09C15.55 18.13 16.32 17.97 17.02 17.61C17.71 17.25 18.29 16.71 18.71 16.05C19.12 15.39 19.35 14.63 19.37 13.85C19.39 13.07 19.2 12.3 18.83 11.62C18.45 10.94 17.89 10.37 17.22 9.97C16.55 9.58 15.78 9.37 15 9.38Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1466_6442">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
